import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Form } from "antd";

import { Typography, Button, Checkbox, Input } from "@atoms";
import { Container, FormParent } from "./register.styles";
import { theme } from "@theme";
import { axiosInstance } from "utils";
import { Wrapper } from "../Login/login.styles";

function Register() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [form] = Form.useForm();
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (isError) {
      form.setFields([
        {
          name: "email",
          errors: [t("registerError")],
        },
      ]);
    }
  }, [isError]);

  const handleClick = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      await axiosInstance.post("/accounts/register/", {
        email: email.toLowerCase(),
        password,
        password_confirm: confirm,
      });

      toast.success("Все прошло отлично!", {
        position: "bottom-right",
        theme: "colored",
      });
      navigate("/register-check-email");
    } catch (err) {
      // @ts-ignore
      const repeatEmail = err?.response?.data?.email?.length >= 1;
      setIsError(repeatEmail);
      // @ts-ignore
      !repeatEmail &&
        toast.error(t("somethingerr"), {
          position: "bottom-right",
          theme: "colored",
        });
    } finally {
      setIsLoading(false);
    }
  };

  const handleValuesChange = async () => {
    form
      .validateFields()
      .then((res) => {
        setIsDisabled(false);
      })
      .catch((err) => {
        setIsDisabled(!!err.errorFields.length);
      });
  };

  return (
    <Wrapper>
      <Container>
        <Typography as="h2">{t("create")}</Typography>
        <Typography
          as="label"
          style={{ color: "rgba(6, 6, 6, 0.8)", textAlign: "center" }}
        >
          {t("createsub")}
        </Typography>
        <Form
          style={{ width: "100%" }}
          form={form}
          layout="vertical"
          onValuesChange={handleValuesChange}
          requiredMark={false}
        >
          <FormParent>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: t("writeEmail") },
                {
                  type: "email",
                  message: t("emailError"),
                },
              ]}
            >
              <Input
                name="email"
                form={form}
                value={email}
                onChange={setEmail}
                placeholder={t("writeEmail")}
              />
            </Form.Item>
            <Form.Item
              label={t("password")}
              name="password"
              rules={[
                { required: true, message: t("comePass") },
                {
                  min: 8,
                  message: t("passwordError"),
                },
              ]}
            >
              <Input.Password
                error={form.getFieldError("password")}
                name="password"
                form={form}
                value={password}
                onChange={setPassword}
                placeholder={t("writePassword")}
              />
            </Form.Item>
            <Form.Item
              label={t("repeatPassword")}
              name="confirm"
              dependencies={["password"]}
              rules={[
                { required: true, message: t("repeatPassword") },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t("passdontmatch")));
                  },
                }),
              ]}
            >
              <Input.Password
                name="confirm"
                form={form}
                value={confirm}
                onChange={setConfirm}
                placeholder={t("writePassword")}
              />
            </Form.Item>
            <Checkbox
              label={t("confirm")}
              checked={isChecked}
              onChange={setIsChecked}
            />
          </FormParent>
        </Form>

        <Button
          variant="primary"
          size="large"
          fullWidth
          disabled={isDisabled || !isChecked}
          loading={isLoading}
          onClick={handleClick}
        >
          <Typography style={{ color: theme.palette.default }}>
            {t("continue")}
          </Typography>
        </Button>

        <Typography>
          {t("haveacc")}{" "}
          <Typography
            as="a"
            href="/login"
            style={{ color: theme.palette.primary, textDecoration: "none" }}
          >
            {t("enter")}
          </Typography>
        </Typography>
        <Typography
          as="a"
          href="/login"
          style={{ color: theme.palette.primary, fontSize: '12px' }}
        >
          {t("userAgreement")}
        </Typography>
      </Container>
    </Wrapper>

  );
}

Register.CheckEmail = () => {
  return (
    <Wrapper>
      <Container>
        <Typography as="h2">Проверьте вашу почту</Typography>
        <Typography
          as="label"
          style={{ color: "rgba(6, 6, 6, 0.8)", textAlign: "center" }}
        >
          Мы отправили письмо на почту для <br /> подтверждения регистрации
        </Typography>

        <Button
          variant="primary"
          size="large"
          fullWidth
          onClick={() => (window.location.href = "mailto:")}
        >
          <Typography style={{ color: theme.palette.default }}>
            Открыть приложение почта
          </Typography>
        </Button>
        <Button
          variant="outlined"
          size="large"
          fullWidth
          onClick={() => (window.location.href = "/")}
          style={{ marginTop: "-8px" }}
        >
          <Typography style={{ color: theme.palette.primary }}>
            Вернуться на главную
          </Typography>
        </Button>
      </Container>
    </Wrapper>
  );
};

export default Register;
